import { FaQuoteLeft } from "react-icons/fa";

const CEONote = () => {
  return (
    <div className=" bg-white ">
      <div className="max-w-[992px] mx-auto">
        <img src="/assets/img/ceo-banner.jpg" alt="" />
      </div>
      <div className="mt-8 max-w-[720px] mx-auto">
        <div className="font-semibold text-sm text-[#53565A]">Message from CEO, Romal Shetty</div>
        <h1 className="font-semibold text-[40px] text-[#0A0A0A] mb-4">Welcome home, colleague for life. </h1>
        <p className="text-[#53565A] text-sm border-b border-b-[#D0D0CE] pb-4">17 Jun 2026</p>
         <div className="mt-8 text-sm text-[#364153] space-y-5">
        <p>Dear colleagues,</p>
        <p>At Deloitte, people are the heart and soul of who we are. This includes every one of you who has been part of our journey thus far. Your contributions, your ideas, and your spirit have helped shape the organisation we are today and continue to influence the path we take forward.</p>
        <p>As our alumni, you are not just part of our past; you're a vital part of our present and our future. You remind us that impact doesn't end when you move on…it multiplies.</p>
        <p>Even as careers evolve and paths diverge, the bond we share remains. The values we built together, of excellence, integrity, collaboration, and care, continue to ripple through every new milestone.</p>
        <p>This alumni portal is your space to reconnect, collaborate, and continue growing together. I look forward to seeing this community thrive and remain closely knit in the years ahead.</p>
        <p>Thank you for being an enduring part of the Deloitte story. Once a colleague, always a colleague for life.</p>
        <p className="font-bold mb-2">Your colleague for life,<br />Romal</p>
      </div>
      </div>
     
    </div>
  );
};

export default CEONote;